<template>
  <div class="home-box">
    <v-row>
      <v-col cols="12" lg="4" md="4" offset-md="4" offset-lg="4" sm="12">
        <div class="ma-2" style="text-align: center">
          <img :src="logo" style="max-width: 150px" alt="CPES" />
        </div>
        <v-layout v-if="showSuccess" class="mt-10">
          <v-alert prominent type="success">
            <v-row align="center">
              <v-col class="grow"
                >Password reset details has been sent your email please
                check.</v-col
              >
              <v-col class="shrink">
                <v-btn
                  dark
                  color="var(--color-primary-blue)"
                  :to="'/login?email='"
                  :loading="loading"
                  depressed
                  >Click here to login</v-btn
                >
              </v-col>
            </v-row>
          </v-alert>
        </v-layout>
        <v-layout row v-if="errors">
          <v-row>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-row>
        </v-layout>
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="#00B3FF"
        ></v-progress-linear>
        <v-card class="pa-3" v-if="!showSuccess">
          <v-card-title dark>
            <p>Forgot Password</p>
          </v-card-title>
          <v-card-text>
            <v-form>
              <v-text-field
                label="Email"
                type="email"
                v-model="email"
                @keydown.enter="login"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="12" md="12" sm="12">
                <v-btn
                  class="white--text"
                  color="#00B3FF"
                  block
                  @click="reset()"
                  :disabled="!email"
                  :loading="loading"
                  depressed
                  >Reset</v-btn
                >
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <div class="text--left">
                  <v-btn color="#00B3FF" text link to="/login"
                    >Back to Login</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { AuthService } from "../../services/auth-service";
import Alert from "@/components/shared/Alert";
export default {
  name: "ForgotPassword",
  components: { Alert },
  data() {
    return {
      email: "",
      logo: require("@/assets/logo.png"),
      showSuccess: false,
      loading: false,
      errors: null,
    };
  },

  methods: {
    reset() {
      this.loading = true;
      AuthService.reset({ email: this.email })
        .then((response) => {
          this.loading = false;
          if (response.data.status_code === 200) {
            this.showSuccess = true;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.showSuccess = false;
          if (error.response.data.status_code === 404) {
            this.errors = [error.response.data.message];
          } else {
            this.errors = error.response.data.message
              ? error.response.data.message.email
              : "error";
          }
        });
    },
    onDismissed() {
      this.errors = null;
    },
  },
};
</script>
<style>
.login-page {
  padding-bottom: 100px;
}
</style>
